import affiliatesContent from './content/affiliates.json';

const affiliatesMock = {
    layoutType: 2,
    data: {
        name: 'affiliates',
        layoutType: 2,
        areasList: [
            {
                id: 'affiliates-page-area',
                name: 'Content',
                componentName: 'Comp:AffiliatesPage',
                content: JSON.stringify(affiliatesContent),
            },
        ],
    },
};

export default affiliatesMock;
